<template>
  <div class="breadcrumbBox">
    <el-page-header @back="goBack" title="返回上一级">
      <template #content>
        <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item v-for="item in routeName" :key="item.path">
        <i
          @click="goHome()"
          v-if="item.path == '/index'"
          class="iconfont icon-quanbuyewu wordColor homeIcon"
        ></i>
        <span v-if="item.path != '/index'">{{ item.name }}</span>
      </el-breadcrumb-item>
    </el-breadcrumb>
      </template>
    </el-page-header>

  </div>
</template>
<script>
import { } from '@/api/api'
export default {
  name: 'breadcrumbBox',
  components: {
  },
  data () {
    return {
    }
  },
  computed: {
    routeName () {
      return this.$route.matched
    }
  },
  mounted () {
  },
  created () {
  },
  methods: {
    goHome () {
      this.$router.push('/home')
    },
    goBack () {
      this.$router.go(-1)
    }
  }
}
</script>
<style lang="scss">
.homeIcon {
  font-size: 22px;
  cursor: pointer;
}
.homeIcon:hover {
  opacity: 0.5;
}
.el-breadcrumb__item {
  display: flex;
  align-items: center;
}
.el-breadcrumb {
  display: flex;
}
.breadcrumbBox {
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  padding: 0 20px;
  border-bottom: 1px solid #f0f0f0;
  box-sizing: border-box;
}
</style>
